import React, { forwardRef, } from "react";
import { Button as ChakraButton, Icon, } from "@chakra-ui/react";
export const Button = forwardRef(({ children, isLoading = false, isDisabled = false, isJustified = false, variant = "secondary", size = "md", icon, directionIcon, ...props }, ref) => {
    let colorScheme;
    let chakraVariant;
    if (variant === "primary") {
        chakraVariant = "solid";
        colorScheme = "forest";
    }
    if (variant === "secondary") {
        chakraVariant = "outline";
    }
    if (variant === "danger") {
        chakraVariant = "solid";
        colorScheme = "red";
    }
    if (variant === "warning") {
        chakraVariant = "ghost";
        colorScheme = "red";
    }
    return (React.createElement(ChakraButton, { ref: ref, isLoading: isLoading, disabled: isLoading || isDisabled, colorScheme: colorScheme, variant: chakraVariant, leftIcon: icon ? React.createElement(Icon, { as: icon, boxSize: 4, ml: -1 }) : undefined, rightIcon: directionIcon ? (React.createElement(Icon, { as: directionIcon, boxSize: 4, mr: -1 })) : undefined, width: isJustified ? "100%" : undefined, size: size, ...props }, children));
});
